import {
  Slide,
  Dialog,
  CircularProgress,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface DynamicDialogProps {
  open: boolean;
  title: string;
  subtitle: string;
  handleOkClose: () => void;
  handleNotOkClose: () => void;
  loading?: boolean;
}

const DynamicDialog = ({
  open,
  title,
  subtitle,
  handleNotOkClose,
  handleOkClose,
  loading = false
}: DynamicDialogProps) => {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      aria-describedby="alert-dialog-dynamic"
      onClose={handleNotOkClose}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-dynamic">{subtitle}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleNotOkClose} disabled={loading}>
          ביטול
        </Button>
        <Button onClick={handleOkClose} disabled={loading} startIcon={loading ? <CircularProgress size={18} /> : null}>
          {loading ? '' : 'אישור'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DynamicDialog;
